import type { AssetEntityNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/asset';
import { getOriginalFile } from '@iconik-io/shared-lib/src/utils/format';

import ContextMenu from '../../components/context_menu/context_menu';
import contextMenuConnector from '../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../components/context_menu/types';
import {
  CONTEXT_MENU_PANELS_POSTER_TYPE,
  connectContextMenuConsumer,
} from '../../contexts/context_menu';
import { segmentTrackEvent } from '../../ducks/analytics_tracking/thunks';
import {
  createPosterFromOriginal,
  createPosterFromVideoElement,
} from '../../ducks/entity_keyframes/thunks';
import {
  selectAssetCloudFiles,
  selectAssetFormats,
} from '../../ducks/pages/asset/selectors';
import { getCurrentRouteParams } from '../../router/current_route_params';
import type { AppDispatch, AppState } from '../../store/types';

const getDefinition: GetDefinition<
  AssetEntityNormalized,
  AppState,
  { currentTimeMs: number; compareActive: boolean }
> = (props, state) => {
  const [contextItem] = props.contextItems;
  const isSubclipAsset = contextItem.type === 'SUBCLIP';

  const { versionId } = getCurrentRouteParams();
  const formats = selectAssetFormats(state, contextItem.id, versionId);
  const cloudFiles = selectAssetCloudFiles(state, contextItem.id, versionId);
  const originalFile = getOriginalFile(formats, cloudFiles);
  const items: ContextMenuItemDefinition[] = [];
  if (props.options.compareActive) {
    items.push({
      label: 'Poster snapshots unavailable while comparing assets',
    });
    return {
      items,
    };
  }
  if (!isSubclipAsset && originalFile) {
    items.push({
      label: 'From Original (best quality - slower)',
      action: () => (dispatch: AppDispatch) => {
        dispatch(
          segmentTrackEvent({
            eventName: 'Create Custom Keyframe',
            properties: {
              Using: 'Original',
            },
          }),
        );
        dispatch(
          createPosterFromOriginal(contextItem.id, props.options.currentTimeMs),
        );
      },
    });
  }

  items.push({
    label: 'From Preview (immediate)',
    action: () => (dispatch: AppDispatch) => {
      dispatch(
        segmentTrackEvent({
          eventName: 'Create Custom Keyframe',
          properties: {
            Using: 'Preview',
          },
        }),
      );
      dispatch(
        createPosterFromVideoElement({
          videoElement: document.querySelector('video'),
          assetId: contextItem.id,
        }),
      );
    },
  });

  return {
    items,
  };
};

const PosterTypeContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_MENU_PANELS_POSTER_TYPE,
);

export default PosterTypeContextMenu;
